export const DASHBOARD_MENU_KEY = "dashboard";
export const INSTITUTES_MENU_KEY = "institutes";
export const ATTENDANCE_MENU_KEY = "attendance";
export const STUDENTS_MENU_KEY = "students";

export type SidebarMenuKey =
	| typeof DASHBOARD_MENU_KEY
	| typeof INSTITUTES_MENU_KEY
	| typeof ATTENDANCE_MENU_KEY
	| typeof STUDENTS_MENU_KEY;
